import { Command } from 'commander';
import type { BrandConfig } from '../branding/types';
import { loadConfig } from '../config/loader';
import { resolveProfile, runConfigSearchPaths } from '../branding/apply';

export function buildValidateCommand(brand: BrandConfig): Command {
  return new Command('validate')
    .description('Validate the local shuttle.yaml without running')
    .option('--config <path>', 'Path to shuttle.yaml config file')
    .option('-p, --profile <name>', 'Config profile to validate (default "default")')
    .action((options: { config?: string; profile?: string }) => {
      try {
        const profile = resolveProfile(brand, options.profile);
        loadConfig({
          explicitPath: options.config,
          searchPaths: runConfigSearchPaths(brand, profile),
          productId: brand.product.id,
        });
        console.log('Configuration is valid');
        process.exit(0);
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        console.error(`Configuration error: ${message}`);
        process.exit(1);
      }
    });
}
